import {CostDto, RegularObjectDto} from "../../../core/interfaces/core.types";
import {UserNotificationDto} from "../../notifications/types/user-notifications.types";


export enum ContractFrequencyEnum {
  individual,
  monthly,
  annually
}

export enum ContractStatusEnum {
  active,
  inactive,
  pending,
  all
}


export interface ContractsRequestDto {

  includeContractPartnerData: boolean;
  includeContractDetails: boolean;
  includeInsurableObjects: boolean;

  filterStatusIds?: ContractStatusEnum[];
  filterGroupIds?: number[];
  filterInsurablePersonsIds?: string[];
  filterInsurableObjectIds?: string[];

  requestedFrequency?: ContractFrequencyEnum;
}

export interface ContractsRuntimeDto {

  totalCost?: CostDto;
  groups?: ContractsRuntimeGroupDto[];
  insurableObjects?: ContractsRuntimeObjectDto[];
  contracts?: ContractsRuntimeInsuranceDto[];

  totalFrequency?: ContractFrequencyEnum;
  contractsFrequency?: ContractFrequencyEnum;

}

export interface ContractsRuntimeGroupDto {

  id: number;
  name: string;
  imageUrl: string;
  cost: CostDto;
  contractIds: number[];
  contracts: number;
  activeContractCost: CostDto;
  activeContractIds: number[];
  activeContracts: number;

}

export interface ContractDocumentDto {

  id: number;
  name: string;
  mimeType: string;
  additionalInformation: string;
  uploadedOn: string;

}

export interface ContractAdditionalDataDto {
  label: string;
  value: string;
}

export interface ContractInfoDto {

  imageUrl: string;
  showImage: boolean;

  label: string;
  value: string;

}


export interface ContractsRuntimeInsuranceDto {
  id: number;

  insuranceType: RegularObjectDto;
  insuranceCompany: RegularObjectDto;
  insuranceSubCompany: RegularObjectDto;

  insuranceIdentNumber: string;

  contractStatus: ContractStatusEnum;

  contractStatusText: string;
  // Ticket DWK1000000764
  startDate: Date | string;
  endDate: Date | string;
  plannedEndDate: Date;

  noticeAvailable: boolean;
  noticePeriod: Date;


  paymentFrequencyText: string;

  autopilotAvailable: boolean;
  autopilotActive: boolean;

  costInfoExist: boolean;

  freePayment: boolean

  cost: CostDto;

  groupId: number;

  //String insurableObject;
  insurableObjects: ContractsRuntimeObjectDto[];
  notifications: UserNotificationDto[];
  documents: ContractDocumentDto[];
  genericData: ContractAdditionalDataDto[];
  infos: ContractInfoDto[];

  notFullyManaged: boolean;

}

export enum ContractInsurableObjectType {
  OBJECT,
  PERSON,
  NONE,
  ME
}

export enum ContractInsurableObjectImageType {
  NONE,
  URL,
  USER
}


export interface ContractsRuntimeObjectDto {

  id: number;
  filterId: string;

  priority: number;
  objectType: ContractInsurableObjectType;
  name: string;
  typeName: string;

  imageType: ContractInsurableObjectImageType;
  imageUrl: string;
  imageUserId: number;

  additionalInformation: string;
  numberOfContracts: number;
  contractIds: number[]
}




